import { FC, useState } from 'react'
import WhiteCheck from '../../assets/icons/white_check.svg'
// import Image from 'next/image'

// interface CheckboxProps {
//   initialState?: boolean | null;
//   onClick: (state: boolean) => void;
// }

const Checkbox = ({ initialState = false, onClick }) => {
  const [isChecked, setIsChecked] = useState(initialState)

  const handleClick = () => {
    setIsChecked((prev) => {
      onClick(prev === true ? false : true)
      return prev === true ? false : true
    })
  }

  const renderCheckboxState = () => {
    switch (isChecked) {
      case false:
        return (
          <div className="w-5 h-5 bg-white border border-border-primary rounded-1.5" />
        )
      case true:
        return (
          <div className="w-5 h-5 bg-background-brand-main rounded-1.5 flex items-center justify-center">
            <img alt="Check" src={WhiteCheck} className="w-[70%] h-[70%]" />
          </div>
        )
      case null:
        return (
          <div className="w-5 h-5 bg-background-brand-secondary border border-border-brand-primary rounded-1.5 flex items-center justify-center">
            <div className="w-[60%] h-[2px] bg-background-brand-main" />
          </div>
        )
      default:
        return null
    }
  }

  return (
    <div className="relative cursor-pointer" onClick={handleClick}>
      {renderCheckboxState()}
    </div>
  )
}

export default Checkbox
